<template>
  <li class="boss-jobtype-details-item">
    <label class="boss-label pega-input"><input
      v-model="checkValue"
      type="checkbox"
      class="boss-input-check"
    >{{ categoryItem.name }}</label>
    <select
      v-if="experienceRangeOptions.length"
      v-model="experienceValue"
      class="boss-input-select pega-width-94"
    >
      <option
        v-for="(option, index) in experienceRangeOptions"
        :key="index"
        :value="option.id"
        :data-test="`option-${index}`"
      >
        {{ option.name }}
      </option>
    </select>
  </li>
</template>

<script>
import _ from 'lodash'
export default {
  props: {
    categoryItem: {
      type: Object,
      required: true
    },
    categoryItemDataMap: {
      type: Object,
      required: true
    },
    showExperience: {
      type: Boolean,
      default: false
    },
    experienceRangeOptions: {
      type: Array,
      default: () => ([])
    },
    defaultExperienceId: {
      type: String,
      default: ''
    }
  },
  computed: {
    checkValue: {
      get () {
        return this.categoryItemDataMap.check
      },
      set (value) {
        this.updateCategoryItem({ ...this.categoryItemDataMap, check: value, experience: this.experienceValue })
      }
    },
    experienceValue: {
      get () {
        return this.categoryItemDataMap.experience !== null ? this.categoryItemDataMap.experience : this.defaultExperienceId
      },
      set (value) {
        this.updateCategoryItem({ ...this.categoryItemDataMap, experience: value, check: this.checkValue ? this.checkValue : !_.isEqual(value, this.defaultExperienceId) })
      }
    }
  },
  methods: {
    updateCategoryItem (value) {
      this.$emit('update-category-item', { id: this.categoryItem.id, value })
    }
  }
}
</script>
